module.exports = __webpack_public_path__ + "static/media/seguridad_negro.46790589.svg";